import React, { memo } from "react";
import { Col, Row } from "antd";

import AddressesField from "../addresses-field/addresses-field";

import "./main-voting-info.scss";
import File from "./file";
import { Title } from "./title";
import { Description } from "./description";
import Period from "./period";

const MainVotingInfo = memo(
	({ form, file, votingId, title, description, period, addresses }) => {
		const { getFieldDecorator, setFieldsValue } = form;

		return (
			<div className="NewVoting__item-block">
				<div className="main-voting-info">
					<Title getFieldDecorator={getFieldDecorator} title={title} />
					<Description
						getFieldDecorator={getFieldDecorator}
						description={description}
					/>
					<Period getFieldDecorator={getFieldDecorator} period={period} />
					<Row gutter={8}>
						<Col span={24}>
							<File
								getFieldDecorator={getFieldDecorator}
								setFieldsValue={setFieldsValue}
								votingId={votingId}
								file={file}
							/>
						</Col>
					</Row>
					<AddressesField addresses={addresses} form={form} />
				</div>
			</div>
		);
	}
);

export default MainVotingInfo;
